module.exports = __webpack_public_path__ + "static/heroTeal-mobile-48741a884f2427defa2efa6642259697.gif";